__turbopack_context__.v({
  "button": "ShareButton-module-scss-module___cm9Aq__button",
  "item": "ShareButton-module-scss-module___cm9Aq__item",
  "list": "ShareButton-module-scss-module___cm9Aq__list",
  "shareButton": "ShareButton-module-scss-module___cm9Aq__shareButton",
});
